import axios from 'axios';
const productBaseUrl = process.env.REACT_APP_API_BASE_URL;

async function getOrderPaymentDetails(orderId, token) {
    if (!orderId) throw new Error('orderId is required');
    if (!token) throw new Error('token is required');
    const url = `${productBaseUrl}/api/orders/${encodeURIComponent(orderId)}/payment-details`;

    try {
        const resp = await axios.get(url, {
           
            headers: {
                Accept: 'application/json',
                Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
            },
            timeout: 10_000,
        });
        return resp.data;
    } catch (err) {
        if (err.response) {
            const { status, statusText, data } = err.response;
            throw new Error(`Request failed: ${status} ${statusText} - ${JSON.stringify(data)}`);
        }
        throw new Error(`Request error: ${err.message}`);
    }
}


async function updateRazorpayOrder(orderId, payload, token) {
    if (!orderId) throw new Error('orderId is required');
    if (!payload || typeof payload !== 'object') throw new Error('payload is required');
    const { oldRazorpayOrderId, newRazorpayOrderId, otp } = payload;
    if (!oldRazorpayOrderId) throw new Error('oldRazorpayOrderId is required');
    if (!newRazorpayOrderId) throw new Error('newRazorpayOrderId is required');
    if (!otp) throw new Error('otp is required');
    if (!token) throw new Error('token is required');

    const url = `${productBaseUrl}/api/orders/update-razorpay-order/${encodeURIComponent(orderId)}`;

    try {
        const resp = await axios.put(url, { oldRazorpayOrderId, newRazorpayOrderId, otp }, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
            },
            timeout: 10_000,
        });
        return resp.data;
    } catch (err) {
        if (err.response) {
            const { status, statusText, data } = err.response;
            throw new Error(`Request failed: ${status} ${statusText} - ${JSON.stringify(data)}`);
        }
        throw new Error(`Request error: ${err.message}`);
    }
}

export {
    getOrderPaymentDetails,
    updateRazorpayOrder
};

